module.exports = __webpack_public_path__ + "static/media/iZen.af9bea05.jpg";